var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgD28SocialHomepage = function SvgD28SocialHomepage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#EFEFF3",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.065 12.748-6.718-6.719a1.428 1.428 0 0 0-2.014.001l-6.718 6.718a1.076 1.076 0 0 0 1.521 1.52l.91-.91v7.031c0 .633.514 1.146 1.147 1.146h2.449v-3.194a.45.45 0 0 1 .45-.45h2.498a.45.45 0 0 1 .45.45v3.194h2.448c.633 0 1.146-.513 1.146-1.146v-7.03l.91.91a1.072 1.072 0 0 0 1.521 0c.42-.42.42-1.101 0-1.521z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
};
export default SvgD28SocialHomepage;